import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { UiCardInfoModule } from '@components/shared/ui-card-info/ui-card-info.module';
import { UiParameterCollectionModule } from '@components/shared/ui-parameter-collection/ui-parameter-collection.module';
import { UiSelectCardGroupModule } from '@components/shared/ui-select-card-group/ui-select-card-group.module';
import { UiCronModule } from '@components/ui-cron/ui-cron.module';
import { UiDateTimePickerModule } from '@components/ui-datetime-picker/ui-datetime-picker.module';
import { UiToggleSwitchModule } from '@components/ui-toggle-switch/ui-toggle-switch.module';
import { SharedModule } from '@modules';
import { ProcessGridModule } from '@pages/process/grids';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import { QueueTriggerComponent } from './queue-trigger/queue-trigger.component';
import { StopAfterComponent } from './stop-after/stop-after.component';
import { TriggerUpsertPageComponent } from './trigger.upsert.page';

@NgModule({
    imports: [
        CommonModule,
        UiNgLetModule,
        MatCardModule,
        SharedModule,
        UiAutofocusModule,
        UiToggleSwitchModule,
        UiSelectCardGroupModule,
        UiCardInfoModule,
        UiCronModule,
        UiDateFormatModule,
        ProcessGridModule,
        UiSuggestModule,
        UiParameterCollectionModule,
        UiDateTimePickerModule,
        UiContentLoaderModule,
        UiSpinnerButtonModule,
    ],
    declarations: [
        TriggerUpsertPageComponent,
        QueueTriggerComponent,
        StopAfterComponent,
    ],
    exports: [TriggerUpsertPageComponent],
})
export class TriggerUpsertModule { }
